function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgSupportBg2 = function SvgSupportBg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1003 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_18340_19939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.863 353.658C866.286 509.658 603.378 403.584 364.863 453.158C126.348 502.732 -6.71367 553.158 -39.1372 397.158C-71.5607 241.158 61.7253 15.8929 260.862 206.518C459.998 397.143 724.36 189.004 833.863 353.658Z",
    fill: "#3EC2FF",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18340_19939",
    x: -210.392,
    y: -32.8844,
    width: 1213.38,
    height: 701.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.2,
    result: "effect1_foregroundBlur_18340_19939"
  }))));
};
export default SvgSupportBg2;